// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { mobileTippyBreakpoint } from "@pace/App/ComponentExtensions/Tippy/TippyPopupExtensions";
import { FormFieldClickable } from "@pace/MobiusOverrides/FormField";
import { searchInputStyles } from "@pace/Overrides/Widgets/Header/SearchInput";
import IconSearch from "@pace/XDL/Icons/IconSearch";
import { color, getSystemColor, styledScrollbar, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

searchInputStyles.tippyPopup = {
    main: {
        css: css`
            &.tippy-box {
                ${xScreen("lte", mobileTippyBreakpoint)} {
                    border: none;
                }
                > .tippy-content {
                    padding: 0;
                    ${xScreen("gt", mobileTippyBreakpoint)} {
                        max-height: none;
                        overflow: hidden;
                    }
                }

                ${xScreen("lte", "sm")} {
                    .content-wrapper {
                        overflow: hidden;
                    }
                }
            }
        `,
    },
};

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        max-height: 585px;
        padding: 1px;
        overflow: hidden;
        ${({ width }: any) => width && `width: ${width}px;`}

        ${xScreen("lte", mobileTippyBreakpoint)} {
            flex-direction: column;
            max-height: 90vh;
        }

        ${xScreen("lte", "sm")} {
            max-height: none;
            width: 100vw;
        }
    `,
};

searchInputStyles.input = {
    iconProps: {
        src: IconSearch,
        color: "secondary",
        size: 15,
    },
    cssOverrides: {
        formInputWrapper: css`
            ${FormFieldClickable} {
                padding: 9px 12px 9px 9px;
                ${IconWrapper} {
                    position: relative;
                    height: auto;
                    width: auto;
                    top: auto;
                    right: auto;
                    padding: 0;
                    svg {
                        height: auto;
                        width: 15px;
                    }
                }
            }
        `,
        formField: css`
            max-width: 881px;
        `,
        inputSelect: css`
            &,
            &:focus {
                padding-left: 13px;
                border-radius: 20px;
            }
            &[aria-expanded="true"] {
                border-color: ${color("primary")};
            }
        `,
    },
};

searchInputStyles.autocompleteColumnWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 319px;
        padding: 18px 16px;
        ${xScreen("lte", mobileTippyBreakpoint)} {
            border-right: 0;
            width: 100%;
        }
    `,
};

searchInputStyles.autocompleteColumnProductWrapper = {
    css: css`
        padding: 17px;
        margin-right: 4px;
        ${({ hasContent }: any) =>
            hasContent
                ? `
                    border-left: 1px solid ${getSystemColor("common.ui12")};
                    width: 567px`
                : `width: 100%`};

        ${styledScrollbar(8, 12)}
        ${xScreen("lte", mobileTippyBreakpoint)} {
            border-left: none;
            padding-right: 4px;
            width: auto;
        }
    `,
};

searchInputStyles.autocompleteColumnProductMobileDivider = {
    css: css`
        display: none;
        ${xScreen("lte", mobileTippyBreakpoint)} {
            height: 1px;
            background-color: ${color("common.border")};
            width: calc(100% - 22px);
            margin: -8px auto 7px auto;
            display: block;
        }
    `,
};
